// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yq55","icon":"styles_icon__18iP3"};